import dynamic from "next/dynamic";
import { NextImage } from "..";
import EditorJSContent from "../../editor-js-content";

import {
  CardsFlexibleItemWrapper,
  InformationWrapper,
  ImageWrapper,
  Title,
  EditorWrapper,
  ButtonWrapper,
} from "./styles";

const Link = dynamic(() => import("../link/link"));

export const CardsFlexibleItem = ({
  icon,
  bodyTitle,
  bodyDescription,
  button,
  buttonType,
}) => {
  const type = buttonType === "primary" ? "buttonPrimary" : "buttonCta";

  return (
    <CardsFlexibleItemWrapper>
      <InformationWrapper>
        {icon && (
          <ImageWrapper>
            <NextImage media={icon} />
          </ImageWrapper>
        )}
        {bodyTitle && <Title>{bodyTitle}</Title>}
        {bodyDescription && (
          <EditorWrapper>
            <EditorJSContent content={bodyDescription} />
          </EditorWrapper>
        )}
      </InformationWrapper>
      {button && (
        <ButtonWrapper>
          <Link type={type} {...button} />
        </ButtonWrapper>
      )}
    </CardsFlexibleItemWrapper>
  );
};

export default CardsFlexibleItem;
